import { render, staticRenderFns } from "./simplifyContract.vue?vue&type=template&id=354d59c7&scoped=true"
import script from "./simplifyContract.vue?vue&type=script&lang=js"
export * from "./simplifyContract.vue?vue&type=script&lang=js"
import style0 from "./simplifyContract.vue?vue&type=style&index=0&id=354d59c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354d59c7",
  null
  
)

export default component.exports